import { ArrowDown, FileText, Users, TrendingUp, Shield } from 'lucide-react';
import { SiteLayout } from '../components/site/SiteLayout';
import { PageHero, CheckList, SectionTitle } from '../components/site/PageHero';
import { PhoneButton } from '../components/site/PhoneButton';
import { BookingBlock } from '../components/site/BookingBlock';
import { QuestionnaireBanner } from '../components/site/QuestionnaireCta';

const OFFERINGS = [
  { Icon: FileText, title: 'Personal Pension Estimates', copy: 'Accurate projections and personalized pension plans designed for your retirement goals.' },
  { Icon: TrendingUp, title: 'ZiVae Income Solutions', copy: 'Strategic income planning to keep you financially stable throughout your retirement years.' },
  { Icon: Shield, title: 'Tax-Smart Strategies', copy: 'Tax-efficient income, Social Security optimization, and legally keeping more of what you earn.' },
  { Icon: Users, title: 'Retirement Seminars', copy: 'Educational webinars and in-person seminars to help you make informed retirement decisions.' },
];

export default function RetirementPlanning() {
  return (
    <SiteLayout testid="retirement-page">
      <PageHero
        testid="retirement-hero"
        eyebrow="Retirement Planning"
        title="Retire on your terms, with a"
        accent="real plan"
        intro="As certified retirement plan consultants, we offer personalized, transparent, and ethical retirement consulting, in person or virtually. We make sure you understand every option before you decide."
        image="/assets/retirement-hero.jpg"
        imageAlt="Friends laughing together at a garden brunch"
        frame="white"
      >
        <div className="space-y-8">
          <CheckList items={['No hidden fees', 'Certified retirement consultants', 'Plans built around your goals and timeline']} />
          <div className="flex flex-wrap items-center gap-6">
            <PhoneButton type="financial" size="lg" testid="retirement-hero-phone" />
            <a href="#book" data-testid="retirement-hero-book-link" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-300 hover:text-orange-300">
              Ready to talk? Book a time <ArrowDown className="w-4 h-4" />
            </a>
          </div>
        </div>
      </PageHero>

      <QuestionnaireBanner testid="retirement-questionnaire" />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20" data-testid="retirement-offerings">
        <SectionTitle kicker="What we do" title="Everything your retirement needs" sub="Comprehensive solutions tailored to your unique needs and goals." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {OFFERINGS.map(({ Icon, title, copy }) => (
            <div key={title} className="glass-panel rounded-3xl p-7 hover:border-orange-400/50 hover:-translate-y-1">
              <Icon className="w-8 h-8 text-orange-400 mb-6" />
              <h3 className="font-display text-xl font-semibold text-white mb-2">{title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{copy}</p>
            </div>
          ))}
        </div>
      </section>

      <BookingBlock kind="retirement" testid="retirement-booking" />
    </SiteLayout>
  );
}
